import { useState } from 'react';

export function useConsent() {
  const [consentChecked, setConsentChecked] = useState(false);
  const [consentError, setConsentError] = useState(false);

  const handleConsentClick = () => {
    setConsentError(consentChecked);
    setConsentChecked(!consentChecked);
  };

  return {
    consentChecked,
    consentError,
    handleConsentClick,
    setConsentError,
  };
}
